<template>
  <div class="app-body-container" style="padding-bottom: 30px">

    <el-row class="mg-t-10">
      <el-col :span="24">
        <el-card shadow="hover" class="mycard-a">
          <div>
            <el-select v-model="searchRules" placeholder="请选择" @change="orderSelection">
              <el-option label="订单号" :value=1></el-option>
              <el-option label="退货单号" :value=2></el-option>
            </el-select>
            <el-input v-model="orderNumber" placeholder="请输入内容"></el-input>
            <el-button type="primary" @click="orderQuery">查询</el-button>
            <!--<el-button @click="advancedSearch=true">高级搜索</el-button>-->
          </div>
          <div style="margin: 20px 0 0 0">
            <el-table
              ref="multipleTable"
              :data="tableDataList"
              tooltip-effect="dark"
              style="width: 100%">
              <el-table-column align="center" header-align="center" label="单号">
                <template slot-scope="scope">
                  <el-button type="text" @click="jumpRouting(scope.$index, scope.row)">{{scope.row.dealNo}}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="客户">
                <template slot-scope="scope">
                  {{scope.row.buyerName}}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" header-align="center" label="下单日期">
                <template slot-scope="scope">
                  {{scope.row.dd1}}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" header-align="center" label="订单金额" width="100">
                <template slot-scope="scope">
                  {{scope.row.finalFee}}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" header-align="center" label="订单状态" width="100">
                <template slot-scope="scope">
                  <span style="color: red">{{scope.row.statesCn}}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" header-align="center" label="支付状态" width="100">
                <template slot-scope="scope">
                  <span style="color: red">{{scope.row.payStatusCn}}</span>
                </template>
              </el-table-column>
              <!--<el-table-column show-overflow-tooltip align="center" header-align="center" label="销售员">-->
                <!--<template slot-scope="scope">-->

                <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column show-overflow-tooltip align="center" header-align="center" label="制单人">-->
                <!--<template slot-scope="scope">-->

                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column show-overflow-tooltip align="center" header-align="center" label="店铺" width="100">
                <template slot-scope="scope">
                  {{scope.row.shopName}}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" header-align="center" label="来源" width="100">
                <template slot-scope="scope">
                  {{scope.row.dataSourceStr}}
                </template>
              </el-table-column>
              <!--<el-table-column show-overflow-tooltip align="center" header-align="center" label="打印状态">-->
                <!--<template slot-scope="scope">-->

                <!--</template>-->
              <!--</el-table-column>-->
            </el-table>

            <!--订单记录(分页)-->
            <div style="margin: 14px">
              <el-pagination style="float: right"
                             background
                             layout="total, sizes, prev, pager, next"
                             :page-size="main$page_size"
                             :current-page="main$curr_page"
                             :total="main$total"
                             @current-change="handlePageChange"></el-pagination>
              <div style="clear: both"></div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!--高级搜索-->
    <el-dialog title="高级搜索" :visible.sync="advancedSearch" width="80%" class="mydialog mydialog_add_order_group" :append-to-body="true">
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col span="12">
            <el-form-item label="单号">
              <el-input v-model="form.name" class="layout"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="客户">
              <el-input v-model="form.name" class="layout"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="下单时间">
              <el-date-picker
                v-model="form.name"
                class="layout"
                type="daterange"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="商品名称">
              <el-input v-model="form.name" class="layout"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="数据来源">
              <el-select v-model="form.name" class="layout">
                <el-option label="数据来源" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="店铺">
              <el-select v-model="form.name" class="layout">
                <el-option label="店铺" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="所属销售">
              <el-select v-model="form.name" class="layout">
                <el-option label="所属销售" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="制单人">
              <el-select v-model="form.name" class="layout">
                <el-option label="制单人" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="订单类型">
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox label="全部"></el-checkbox>
            <el-checkbox label="订货单"></el-checkbox>
            <el-checkbox label="合并订单"></el-checkbox>
            <el-checkbox label="退货单"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox label="全部"></el-checkbox>
            <el-checkbox label="待审核"></el-checkbox>
            <el-checkbox label="待发货"></el-checkbox>
            <el-checkbox label="已完成"></el-checkbox>
            <el-checkbox label="已取消"></el-checkbox>
            <el-checkbox label="已作废"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="退货状态">
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox label="全部"></el-checkbox>
            <el-checkbox label="待退货审核"></el-checkbox>
            <el-checkbox label="待入库"></el-checkbox>
            <el-checkbox label="已作废"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox label="全部"></el-checkbox>
            <el-checkbox label="待收款"></el-checkbox>
            <el-checkbox label="已收款"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="打印状态">
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox label="全部"></el-checkbox>
            <el-checkbox label="未打印"></el-checkbox>
            <el-checkbox label="已打印"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="备注留言">
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox label="全部"></el-checkbox>
            <el-checkbox label="有留言备注"></el-checkbox>
            <el-checkbox label="无留言备注"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="">清空</el-button>
        <el-button @click="">取消</el-button>
        <el-button type="primary" @click="">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ElRow from "element-ui/packages/row/src/row";
  import ElCol from "element-ui/packages/col/src/col";
  export default {
    components: {
      ElCol,
      ElRow},
    data: function () {
      return {
        advancedSearch:false, //高级搜索弹框
        searchRules:1, //搜索规则
        orderNumber:'', //订单号
        form:{
          name:'',
          checkList:[],
        },

        tableDataList:[], //数据列表

        main$page_size: 10,
        main$curr_page: 1,
        main$total: 0,
      }
    },
    methods: {
      //跳转路由
      jumpRouting(index,row){
        window.open('//corp.hixiaoxiao.com/xxadmin/index.html#/fullordersee/'+parseFloat(row.dealId))
      },
      //订单选择
      orderSelection(){
        this.orderQuery();
      },
      //订单查询
      orderQuery(){
        let self = this;
        let post = {
          "page":self.main$curr_page,//分页页数
          "rows":self.main$page_size,//分页大小
          "dataSource":"01",//数据来源
          "dealType":self.searchRules,//单据类型 1订单 2退货单 3物流单
          "dealNo":self.orderNumber,//单据编号
          "buyerName":"",//客户名称
          "salesmanName":"",//销售员姓名
          "states":'',//订单状态
          "payStatus":'',//支付状态 0未支付 1已支付
          "begin":"",//开始时间
          "end":""//结束时间
        };
        self.xFetch.post(self.xApi('/robot/order/getOrderList'), post).then(function (res) {
//          console.log(res.data);
          if(res.data.code=='00'){
            self.main$total = res.data.total;
            self.tableDataList=res.data.rows
          }
        });
      },
      handlePageChange: function (val) {
        this.main$curr_page = val;
        this.orderQuery();
      },
    },
    created: function () {
      this.orderQuery(); //订单查询
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-input, .el-select, .el-date-editor.el-input{
    width: 220px;
  }
  .layout{
    width: 100%;
  }
  .mycard-title{ color: #333 }
  .mycard-title .mycard-title-icon{ font-size: 18px;position: relative;top: -5px }
  /*query-box*/
  .query-box{ border-bottom: 1px solid #F0F2F5;padding-bottom: 20px;margin-bottom: 20px }

  /*mydialog_add_order_group*/
  .mydialog_add_order_group{ }
  .mydialog_add_order_group .dg-input{ width: 220px }
  .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399; }
</style>
<style>
  /*mydialog_add_order_group*/
  .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/order/inquiry.vue